import { Cookies } from 'react-cookie';

import { HeatMapDataResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHeatMapMCTData = async (
  planSlug: string,
  dateStart: string = '2025-05-01',
  dateEnd: string = '2025-05-31',
  type: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/${type}-heat-map/${planSlug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      date_start: dateStart,
      date_end: dateEnd,
    },
  });

  return data.data as HeatMapDataResponse;
};
